<template>
    <vue-plyr ref="plyrVideo" class="plyr-custom">
        <slot v-show="videoIsLoad"></slot>
        <slot name="poster" v-if="!videoIsLoad"></slot>
    </vue-plyr>
</template>
<script type="text/babel">
export default {
    name: 'plyr-video',
    data() {
        return {
            videoIsLoad: false
        }
    },
    computed: {
        player () {
            return this.$refs.plyrVideo.player
        }
    },
    methods: {

    },
    mounted () {

        this.player.on('ready', () => {
            this.player.autoplay = true;
            this.player.loop = true;
            this.player.muted = true;
            this.player.play();
            setTimeout(() => {
                this.videoIsLoad = true;
            }, 1000);
        });
        this.player.on('canplay', () => {
            console.log(this.player);
        });
    }
}
</script>
<style lang="scss" >
    .plyr-custom .plyr {
        pointer-events: none;
    }
    .plyr-custom .plyr__video-wrapper, .plyr-custom .plyr {
        position: static;
    }
    .plyr-custom .main-title__video {
        position: absolute;
        left: auto;
        top: 0;
        right: 0;
        height: auto !important;
        z-index: 0;
        width: auto !important;
        min-width: 100%;
        min-height: 100%;
        max-width: none !important;
        max-height: 100%;
        display: block;
    }
</style>



// WEBPACK FOOTER //
// src/components/video.vue